import { inject, Injectable } from "@angular/core";
import { UpdateAgendaService } from "../../../api/services";
import { UpdateAgendaDto } from "../../../api/models";
import { Observable } from "rxjs";
import { UpdateAgendaControllerUpdate$Params } from "../../../api/fn/update-agenda/update-agenda-controller-update";
import { environment } from "../../../environments/environment";
import { LoggedUserService } from "@keus-template/auth";

@Injectable({
  providedIn: "root",
})
export class UpdateAgendaApiService {
  /** Injected service for logged user */
  private readonly _loggedUserService: LoggedUserService =
    inject(LoggedUserService);

  private readonly _updateAgendaService: UpdateAgendaService =
    inject(UpdateAgendaService);

  public update$(body: UpdateAgendaDto): Observable<void> {
    const email = this._loggedUserService.currentUser().email;

    const params: UpdateAgendaControllerUpdate$Params = {
      body,
      tenant: environment.tenant,
      email,
    };

    return this._updateAgendaService.updateAgendaControllerUpdate(params);
  }
}
